import request from '@/middleware/request'

const getCaller = data => {
  // const res = encodeURI(
  //   `/caller?page=${obj.page}&limit=${obj.perPage}&search=${obj.search}&from=${obj.startDateTime}&to=${obj.endDateTime}&sort=${obj.sortBy}|${obj.sort}&channel=${obj.channel}&customer=${obj.customer}`
  // )
  return request({
    url: '/caller/list',
    method: 'post',
    data
  })
}

const getDataFilter = data => {
  return request({
    url: '/caller/list/data_filter',
    method: 'post',
    data
  })
}

const getMediaUrl = url => {
  return request({
    url,
    method: 'get'
  })
}

const getConversation = session_id => {
  return request({
    url: `/caller/conversation/${session_id}`,
    method: 'get'
  })
}

const updateWrapUp = (session_id, data) => {
  return request({
    url: `/caller/wrap_up/${session_id}`,
    method: 'patch',
    data
  })
}

const updateField = (session_id, data) => {
  return request({
    url: `/caller/field/${session_id}`,
    method: 'patch',
    data
  })
}

const updateBotQc = data => {
  return request({
    url: `/caller/bot_qc`,
    method: 'patch',
    data
  })
}

const clearBotQc = session_id => {
  return request({
    url: `/caller/bot_qc/clear/${session_id}`,
    method: 'get'
  })
}

const discussBotQc = data => {
  return request({
    url: `/caller/bot_qc/discuss`,
    method: 'patch',
    data
  })
}

const getWordAccuracy = data => {
  return request({
    url: '/caller/bot_qc/word_accuracy',
    method: 'post',
    data
  })
}

const getQcVerified = data => {
  const queryParams = new URLSearchParams()

  for (const [key, value] of Object.entries(data)) {
    if (value !== null && value !== undefined) {
      queryParams.append(key, encodeURIComponent(value))
    }
  }

  return request({
    url: `/caller/bot_qc/verify?${queryParams.toString()}`,
    method: 'get'
  })
}

const updateQcVerified = data => {
  return request({
    url: '/caller/bot_qc/verify',
    method: 'patch',
    data
  })
}

export default {
  getCaller,
  getDataFilter,
  getMediaUrl,
  getConversation,
  updateWrapUp,
  updateField,
  updateBotQc,
  clearBotQc,
  discussBotQc,
  getWordAccuracy,
  getQcVerified,
  updateQcVerified
}
